<template>
<!-- 合同支付、续费页面 -->
  <div>
    <navigation-bar></navigation-bar>
    <el-row class="body">
      <el-col :span="16">
        <!-- 提示 -->
        <div class="prompt">
          <i class="el-icon-warning-outline"></i>
          请于7天内完成付款，超过时间合同将自动取消
        </div>
        <!-- main -->
        <div class="main">
          <div class="title">购买{{title}}</div>
          <!-- table -->
          <el-table
            :data="tableData"
            style="width: 100%;margin-bottom: 20px;"
            row-key="id"
            border
            default-expand-all
            :header-cell-style="{background:'rgba(233, 239, 255, 1)',color:'#2A2A2A'}"
            :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
            <el-table-column
              prop="contractId"
              label="合同号"
              min-width="130">
            </el-table-column>
            <el-table-column
              prop="name"
              label="服务名称">
            </el-table-column>
            <el-table-column
              label="购买时长">
              <span>1年</span>
            </el-table-column>
            <el-table-column
              prop="price"
              label="产品单价">
            </el-table-column>
            <el-table-column
              prop="totalPrice"
              label="应付总额">
            </el-table-column>
          </el-table>
          <!-- 支付方式 -->
          <div class="payment_methods">
            <span>支付方式:</span>
            <div class="payment_item current_payment">平台支付</div>
            <!-- <div class="payment_item">平台支付</div>
            <div class="payment_item">平台支付</div> -->
          </div>
          <!-- 支付选项 -->
          <div class="payment_options">
            <div class="options_item" @click="choicePayment('A01')">
              <img src="../../../assets/console/htgl/zfb.png" alt="">
              <div class="selected" v-if="paymentMethod == 'A01'">
                <img src="../../../assets/console/htgl/tick_red.png" alt="">
              </div>
            </div>
            <div class="options_item" @click="choicePayment('W01')">
              <img src="../../../assets/console/htgl/wxzf.png" alt="">
              <div class="selected" v-if="paymentMethod == 'W01'">
                <img src="../../../assets/console/htgl/tick_red.png" alt="">
              </div>
            </div>
            <div class="options_item" @click="choicePayment('U01')">
              <img src="../../../assets/console/htgl/zxzf.png" alt="">
              <div class="selected" v-if="paymentMethod == 'U01'">
                <img src="../../../assets/console/htgl/tick_red.png" alt="">
              </div>
            </div>
          </div>
          <!-- 应付总额 -->
          <div class="total_amount">
            <span>应付总额:</span>
            <div>￥{{this.totalAmount / 100}}</div>
          </div>
          <!-- 支付按钮 -->
          <div class="submit_button" @click="payContract">确认支付</div>
        </div>
        <!-- dialog -->
        <el-dialog :visible.sync="dialogVisible" center width="30%">
          <template slot="title">
              <div class="dialog_title">确认支付</div>
          </template>
          <!-- <div class="dialog_content">
            <div>请您在新打开的页面进行支付</div>
            <span>支付完成前请不要关闭此窗口</span>
          </div> -->
          <div class="dialog_main">
            <img :src="payErweim" alt="">
          </div>
          <span slot="footer" class="dialog-footer">
            <div class="confirm_button" @click="completePayment">已完成支付</div>
            <div @click="dialogVisible=false">更换支付方式</div>
          </span>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
    import { queryListByContractId, addOrderAndReturn, createPayQRCode } from '@/api/console/contractManagement.js'
    import { addResource } from '@/api/console/resourceManagement.js'
    import NavigationBar from '../../../components/console/navigationBar.vue'
    import token from '@/utils/token.js'
    import axios from 'axios'
    export default {
        data() {
            return {
              title: '',
              contractId: '',//合同id
              detailData: {},//合同列表页传递过来的数据
              contractDetail: [],//合同详情列表
              totalAmount: '',//合同总价
              tableData:[],
              dialogVisible: false,
              paymentMethod: 'A01',//支付方式
              orderNumber: '',//订单号
              payLink: '',//支付链接
              payErweim: '',//支付二维码
            }
        },
        components: {
            NavigationBar
        },
        created() {
          this.getData();
        },
        methods: {
          getData() {
            if(this.$route.query.contractId) {
              this.contractId = this.$route.query.contractId;
              queryListByContractId(this.contractId).then(res => {
                this.contractDetail = res.data.list;
                let arr = [];
                this.contractDetail.forEach((e) => {
                  if(e.parentId == 0) {
                    arr.push({
                      ...e,
                      key: Date.now(),
                      children: [],
                    });
                  } else {
                    arr.forEach((value) => {
                      if(e.parentId == value.productId) {
                        value.children.push({
                          ...e,
                          key: Date.now()
                        })
                      }
                    })
                  }
                });
                // console.log(('表格数据---------------------'));
                // console.log(arr);
                this.tableData = arr;
                this.title = arr[0].name;
                this.totalAmount = (arr[0].totalPrice - 0) * 100;
              })
            } else if(this.$route.query.data) {
              //拿到页面传递过来的数据
              this.detailData = JSON.parse(this.$route.query.data);
              this.totalAmount = (this.detailData.totalPrice - 0) * 100;
              this.contractId = this.detailData.contractId;//合同id
              this.tableData.push(this.detailData);//转换成表格数据
            }
          },
          //选择支付方式
          choicePayment(value) {
            this.paymentMethod = value;
          },
          //在线支付合同
          payContract() {
            this.dialogVisible = true;
            //新增订单
            let param = {
              contractId: this.contractId,
              userId: token.getUser().id
            }
            addOrderAndReturn(param).then(res => {
              // console.log('新增订单------------');
              // console.log(res);
              this.orderNumber = res.data.message.orderId;
              //在线支付
              let params = {
                acct: '',
                // appId: '',
                // appName: '',
                asinfo: '',
                benefitdetail: '',
                body: '',
                // channelId: '',
                chnlstoreid: '',
                // clientId: '',
                // clientIp: '',
                // countryCode: '',
                // currency: '',
                cusip: '',
                extendparams: '',
                fqnum: '',
                goodsTag: '',
                idno: '',
                limitPay: '',
                // locale: '',
                // nickName: '',
                notifyUrl: 'http://121.37.136.73:40003/payment/receiverPayCallback',//交易结果通知地址
                frontUrl: 'http://ropewaycloud.com/#/resourceManagement',//支付完成跳转地址
                paytype: this.paymentMethod,//交易方式
                remark: '',
                // repeatCode: '',
                reqsn: this.orderNumber,//交易订单号
                // sessionId: '',
                // sign: '',
                subAppid: '',
                subbranch: '',
                // tagId: '',
                // timeZone: '',
                // timestamp: '',
                truename: '',
                // trxamt: this.totalAmount,//交易金额，单位为分
                trxamt: 1,
                // userId: '',
                validtime: '',
                // versionCode: ''
              }
              axios({
                method: 'POST',
                url: 'http://121.37.136.73:40003/payment/onlinePay',
                data: {
                  ...params
                }
              }).then(res => {
                this.payLink = res.data.data.payinfo;
                //生成支付二维码
                createPayQRCode(this.payLink).then(res => {
                  this.payErweim = res.data;
                })
              })
            })
          },
          //已完成支付
          completePayment() {
            queryListByContractId(this.contractId).then(res => {
              // console.log(res.data.list);
              let result = res.data.list;
              let totalName = result[0].name;
              let expirationTime = this.getExpirationTime(result[0].createTime)
              if(result[0].payStatus == '0000') {//支付成功
                let arr = [];
                result.forEach(e => {
                  arr.push({
                    contractId: e.contractId,
                    createTime: e.createTime,
                    expirationTime: expirationTime,
                    name: e.name + '('+totalName+')',
                    productId: e.productId,
                    runStatus: '0',
                    userId: e.userId
                  })
                })
                arr.shift();
                console.log(arr);
                addResource(arr).then(res => {
                  // console.log('新增资源信息-----------------');
                  // console.log(res);
                  this.$router.push({path: '/resourceManagement'})
                })
              } else {//支付失败
                this.$router.push({path: '/contractManagement'})
              }
            })
          },
          //获得过期时间
          getExpirationTime(date) {
            let d1 = date;
            let d2 = new Date(d1);
            d2.setFullYear(d2.getFullYear()+1); 
            d2.setDate(d2.getDate()-1);
            let d3 = d2.toLocaleString();
            let  d4 = d3.replace(/\//g, '-');
            return d4
          }
        }
    }
</script>
<style lang="scss" scoped="scoped">
    .body {
      display: flex;
      justify-content: center;
      height: 1000px;
      margin-top: 80px;
      background-color: #F6F6F7;
      .prompt {
        height: 30px;
        margin: 20px 0 25px;
        border: 1px solid #537EEE;
        background-color: #E9EFFF;
        font-size: 12px;
        color: #2A2A2A;
        line-height: 30px;
        i {
          margin: 0 5px 0 20px;
          font-size: 16px;
          color: #537EEE;
        }
      }
      .main {
        position: relative;
        padding: 15px 40px;
        border: 1px solid #E5E5E5;
        background-color: #fff;
        .title {
          color: #4F4F4F;
        }
        .el-table {
          margin: 30px 0;
          font-size: 12px;
          /deep/ th {
              padding: 4px;
              font-weight: 400;
          }
          /deep/ td {
              padding: 10px;
          }
          /deep/ .cell {
            overflow: visible;
          }
        }
        // 支付方式
        .payment_methods {
          display: flex;
          align-items: center;
          span {
            margin-right: 20px;
            font-size: 12px;
            color: #4F4F4F;
          }
          .payment_item {
            width: 132px;
            height: 32px;
            margin-right: 2px;
            background-color: #E9EFFF;
            font-size: 14px;
            color: #2A2A2A;
            text-align: center;
            line-height: 32px;
          }
          .payment_item:hover {
            cursor: pointer;
          }
          .current_payment {
            background-color: #537EEE;
            color: #fff;
          }
        }
        // 支付选项
        .payment_options {
          overflow: hidden;
          margin: 30px 0 70px;
          .options_item {
            position: relative;
            float: left;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 23%;
            height: 48px;
            margin-right: 1%;
            border: 1px solid #E5E5E5;
            img {
              height: 70%;
            }
          }
          .options_item:hover  {
            cursor: pointer;
          }
          .selected {
            position: absolute;
            width: 100%;
            height: 48px;
            border: 1px solid #C12B31;
            img {
              position: absolute;
              bottom: 0;
              right: 0;
              width: 37px;
              height: 28px;
            }
          }
        }
        // 应付总额
        .total_amount {
          display: flex;
          justify-content: right;
          align-items: flex-end;
          margin-bottom: 60px;
          span {
            margin-right: 20px;
            font-size: 12px;
            color: #4F4F4F;
          }
          div {
            font-size: 30px;
            color: #C12B31;
          }
        }
        .submit_button {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 132px;
          height: 32px;
          background-color: #C12B31;
          font-size: 14px;
          color: #fff;
          text-align: center;
          line-height: 32px;
        }
        .submit_button:hover {
          cursor: pointer;
        }
      }
      .el-dialog {
        .dialog_title {
          height: 68px;
          background-color: #E9EFFF;
          font-size: 20px;
          color: #507DF1;
          text-align: center;
          line-height: 68px;
        }
        .dialog_content {
          margin: 20px 0 10px;
          font-size: 16px;
          color: #4F4F4F;
          text-align: center;
          span {
            font-size: 12px;
          }
        }
        .dialog_main {
          text-align: center;
          img {
            width: 250px;
            height: 250px;
          }
        }
        .dialog-footer {
          display: flex;
          justify-content: center;
          div {
            width: 40%;
            height: 30px;
            margin-right: 10px;
            border: 1px solid #E5E5E5;
            font-size: 14px;
            color: #4F4F4F;
            text-align: center;
            line-height: 32px;
          }
          div:hover {
            cursor: pointer;
          }
          .confirm_button {
            background-color: #C12B31;
            color: #fff;
          }
        }
      }
    }
</style>
<style lang="scss">
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #537EEE;
  }
  .el-dialog__header {
    padding: 0;
  }
</style>